import * as React from "react";
import cx from "classnames";
import style from "./DigitalTwin.css";
import { ButtonLink } from "components/Button";
import { Shape } from "components/Shape";

export const DigitalTwin = () => (
  <section className={style.root}>
    <Shape className={style.shape1} />
    <Shape className={style.shape3} />

    <div className={cx(style.content)}>
      <div className="container">
        <h2 className={cx(style.header, "wow", "fadeInUp")}>Digital Twin</h2>
        <p className={cx(style.desc, "wow", "fadeInUp")}>
        The BlockScience team built and open-sourced <a href="http://cadcad.org" target="_blank" rel="noopener noreferrer">cadCAD</a> (complex adaptive dynamics Computer-Aided Design) which is a python-based modeling framework for research, validation, and computer-aided design of complex systems. Whether iterating on a new business model or designing automated smart contract logic on a blockchain, developing a digital representation, a “Digital Twin”, allows you to simulate, test, and validate your ideas prior to implementation.
        </p>
      </div>
    </div>
  </section>
);
